import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";

type InsuranceCoverageMonitorSettings =
  insuranceMonitorApiSpec.InsuranceCoverageMonitorSettings;

export const selectorPolicyTypesFromSettings = (
  insuranceCoverageMonitorSettings?: InsuranceCoverageMonitorSettings
) => {
  return insuranceCoverageMonitorSettings?.coverages?.map(
    coverage => coverage.policyType
  );
};
